import { Component, OnInit, OnDestroy } from '@angular/core';
import { ContextChange, WidgetStyle } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';

@Component({
    // selector: 'app-personal-visit-filter',
    template: '<app-visit-role-admin></app-visit-role-admin>',
    standalone: false
})
export class VisitRolesAdminWidgetComponent extends AbstractWidgetComponent {

  constructor() {
    super();
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
